// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'jsx' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css, jsx } from "@emotion/react";
import * as React from "react";

import { trackChartLegendClick } from "helpers/analytics-reports";
import { getFormattedNumberValue } from "helpers/string";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IChartLegend } from "./Chart";
import { StretchedLink } from "./StretchedLink";
import { defaultNameResolver } from "./helpers/chart-legend";
import {
  colorShapeStyles,
  containerStyles,
  extraMarginStyles,
  headerStyles,
  inactiveStyles,
  labelStyles,
  legendElementStyles,
  namePartStyles,
  nameStyles,
  singleSeriesContainer,
  valueContainerStyles,
} from "./styled/chart-legend";

interface IProps {
  legend: IChartLegend[];
  activeIndex?: string | null;
  ignoreAloneSeries?: boolean;
  trackingChartName?: string;
  onMouseOver?(legend: IChartLegend): void;
  onMouseLeave?(legend: IChartLegend): void;
  urlResolver?(legend: IChartLegend, legendSeries?: IChartLegend[], index?: number): string;
  nameResolver?(legend: IChartLegend, legendSeries?: IChartLegend[], index?: number): string[];
}

export const ChartLegend: React.FC<IProps> = ({
  legend,
  activeIndex,
  ignoreAloneSeries = true,
  onMouseOver,
  onMouseLeave,
  urlResolver,
  nameResolver = defaultNameResolver,
  trackingChartName,
}) => (
  <div css={[containerStyles, legend.length > 1 && extraMarginStyles]}>
    {legend.map((legendSeries, index) => {
      const { color, name, label, value } = legendSeries;

      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const handleMouseOver = () => onMouseOver && onMouseOver(legendSeries);
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const handleMouseLeave = () => onMouseLeave && onMouseLeave(legendSeries);

      const isActive = !activeIndex || activeIndex === color;

      const LegendComponent = urlResolver && !legendSeries.disableLink ? StretchedLink : "div";
      const onClick =
        urlResolver && !legendSeries.disableLink && trackingChartName
          ? // FIXME: Fix this the next time the file is edited.
            // @ts-expect-error TS(2345)
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            () => trackChartLegendClick(trackingChartName, name)
          : null;

      const displayNameParts =
        ignoreAloneSeries && legend.length === 1 ? [] : nameResolver(legendSeries, legend, index);

      return (
        <div css={singleSeriesContainer} key={index.toString()}>
          <LegendComponent
            css={[legendElementStyles, !isActive && inactiveStyles]}
            key={index.toString()}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            href={urlResolver && urlResolver(legendSeries, legend, index)}
            // @ts-expect-error TS(2322)
            onClick={onClick}
          >
            <div css={headerStyles}>
              {color && (
                <div
                  css={[
                    colorShapeStyles,
                    css`
                      background-color: ${color};
                    `,
                  ]}
                />
              )}
              {displayNameParts.length ? (
                <div css={nameStyles}>
                  {displayNameParts.map((displayNamePart, namePartIndex) => (
                    <div
                      key={namePartIndex.toString()}
                      css={namePartIndex > 0 && namePartStyles}
                      title={displayNamePart}
                    >
                      {displayNamePart}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
            <div css={valueContainerStyles}>
              {getFormattedNumberValue(value)}
              {label && <div css={labelStyles}>{label}</div>}
            </div>
          </LegendComponent>
        </div>
      );
    })}
  </div>
);
